export { default } from '@glimmer/component/-private/ember-component-manager';
